import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LckrRoutingModule } from './lckr-routing.module';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ListComponent } from './list/list.component';
import { ListKeywordDetailsComponent } from './list-keyword-details/list-keyword-details.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import {MatDialogModule} from '@angular/material/dialog';
import { FormsModule, NgModel, ReactiveFormsModule } from '@angular/forms';
import { NgbAccordionModule, NgbModule, NgbPaginationModule, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { LckrComponent } from './lckr.component';
import { MatSelectModule } from '@angular/material/select';
import { FilterPipe } from '../shared/pipes/filter.pipe';
import { NgxLoadingModule } from "ngx-loading";
import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {ScrollingModule} from '@angular/cdk/scrolling';
import { DashboardSettingsComponent } from './dashboard-settings/dashboard-settings.component';
import {MatListModule} from '@angular/material/list';
import { KeywordFinderComponent } from '../keyword-finder/keyword-finder/keyword-finder.component';
import { TooltipModule } from 'ng2-tooltip-directive';
import { Dashboard2Component } from './dashboard2/dashboard2.component';

const config: SocketIoConfig = {
	url: "https://socket.strell.io", // socket server url;
	options: {
		transports: ['websocket']
	}
}
@NgModule({
  declarations: [
    DashboardComponent,
    ListComponent,
    ListKeywordDetailsComponent,
    LckrComponent,
    FilterPipe,
    DashboardSettingsComponent,
    Dashboard2Component,
  ],
  imports: [
    CommonModule,
    LckrRoutingModule,
    MatTabsModule,
    MatCardModule,
    MatFormFieldModule,
    ClipboardModule,
    MatInputModule,
    MatButtonToggleModule,
    MatProgressBarModule,
    MatSlideToggleModule,
    MatMenuModule,
    MatTooltipModule,
    MatExpansionModule,
    MatDialogModule,
    MatIconModule,
    MatSelectModule,
    NgbPaginationModule,
    NgbPopoverModule,
    FormsModule,
    NgbModule,
    NgbAccordionModule,
    ReactiveFormsModule,
    MatSnackBarModule,
    ScrollingModule,
    MatListModule,
    TooltipModule,
    NgxLoadingModule.forRoot({}),
    SocketIoModule.forRoot(config), 
  ]
})
export class LckrModule { }
